import React, { Fragment } from "react";
import { Card, CardBody } from "reactstrap";
import subIcon from "../../images/submit.svg";
import Background from "../../images/cus-bg.svg";

export default function UserSuccessDetails(props) {
  const { agency } = props;
  return (
    <>
      <Fragment>
        <div
          className="urs-bg1"
          style={{ backgroundImage: `url(${Background})` }}
        >
          <Card
            style={{
              margin: "auto",
              // marginLeft: "119px",
              // marginRight: "119px",
              // marginBottom: "auto",
              marginTop: "254px",
              minWidth: "900px",
              maxWidth: "900px",
            }}
          >
            <CardBody style={{ textAlign: "center" }}>
              <div>
                <img
                  src={subIcon}
                  style={{ width: "100%" }}
                  alt=""
                  className="main-image centered-image"
                />
                <p className="sub-high-text">Submission successful!</p>
                <p className="sub-text">
                  {`The ${agency} team will review your license details, and once
                  approved, You'll receive an email with the payment link`}
                </p>
              </div>
            </CardBody>
          </Card>
        </div>
      </Fragment>
    </>
  );
}
